import { render, staticRenderFns } from "./tabEight.vue?vue&type=template&id=50db44d8"
import script from "./tabEight.vue?vue&type=script&lang=js"
export * from "./tabEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports